<template>
  <!-- 对话框 -->
  <el-drawer title="添加司机信息" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="80%">

    <!-- 基本信息表单 -->
    <div class="form-box">



      <template>

        <el-form ref="form" :model="submit_data" label-width="80px" style="height: 90vh; overflow-y: auto;">


          <div class="time-save-box">
            <el-dialog :visible.sync="dialogVisible" width="30%" :modal="false" center>



              <div class="block">

                <el-date-picker v-model="time_arrway" type="datetimerange" range-separator="至" start-placeholder="开始日期"
                  end-placeholder="结束日期" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 100%;">
                </el-date-picker>

              </div>


              <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmBtn">确 定</el-button>
              </span>
            </el-dialog>
          </div>

          <h4>已选广告</h4>
          <div class="adver-selection">

            <div class="adver" v-for="(item, index) in selection_advert_name" :key="index" @click="openMore(index)">


              <div style="position: relative;">
                <el-image :src="selection_img_url[index]"
                  style="width: 80px;height: 80px; border: 1px solid #eee;border-radius: 10px;display: block;margin: 0 auto;">
                </el-image>


                <p style="text-align: center;margin: 10px 0;">

                  {{ item }}

                </p>
                <el-button type="danger" icon="el-icon-close" style="position: absolute;right: 0px;top: 0px;"
                  @click.stop="delSelection(index)">
                </el-button>
              </div>

              <div class="time-box">
                <p style="text-align: center;">开始时间:{{ time_box_arrway[index][0] }}</p>

                <p style="text-align: center;">结束时间:{{ time_box_arrway[index][1] }}</p>
              </div>

            </div>

          </div>



          <h4>广告列表</h4>
          <div class="adver-list">

            <div class="adver" v-for="(item, index) in list_advert_name" :key="index" @click="adverClick(index)">
              <div style="display: flex;">
                <el-image :src="list_img_url[index]"
                  style="width: 80px;height: 80px; border: 1px solid #eee;border-radius: 10px;"></el-image>
                <p style="width: 70%;display: flex;align-items: center;justify-content: center;">{{ item }}</p>
              </div>
            </div>

          </div>


          <el-form-item label="备注:" label-width='120px' style="margin-top: 20px;">
            <el-input v-model="submit_data.remarks" :placeholder="submit_rules.remarks.placeholder" style="width: 80%;">
            </el-input>
          </el-form-item>
          <!-- 分页组件 -->
          <div class="pagination">
            <el-pagination layout="prev, pager, next" :page-size="search_data.limit" :total="result_data.count" @current-change="pages_function">
            </el-pagination>
          </div>


        </el-form>



        <!-- 对话框底部按钮 -->
        <div style="display: flex;justify-content: center">
          <el-button type="primary" @click="onSubmit">保存</el-button>
          <el-button @click="closeDialog">关闭</el-button>
        </div>

      </template>

    </div>


    <el-dialog :visible.sync="advertAppointDetails_isShow" :with-header="false" :before-close="closeDetailsDialog"
      width="75%" :modal="false">
      <!-- 详情组件 -->
      <advertAppointDetails :data="advertAppointDetails_arrway" :isShow="advertAppointDetails_isShow">
      </advertAppointDetails>
      <!-- 对话框底部按钮 -->
      <div style="display: flex;justify-content: center;margin-top: 10px;">
        <el-button @click="closeDetailsDialog">关闭</el-button>
      </div>

    </el-dialog>


  </el-drawer>
</template>

<script>
  var _this;
  import advertAppointDetails from './advertAppointDetails.vue';
  export default {
    components: {
      advertAppointDetails
    },
    props: {
      'isShow': Boolean,
      'data': '',
    },
    watch: {

      isShow(newData, oldData) {



        _this.show = true;



        _this.list_advert_name.length = 0;
        _this.list_img_url.length = 0;
        _this.selection_advert_name.length = 0;
        _this.selection_img_url.length = 0;
        _this.time_box_arrway.length = 0;
        _this.list_advert_code.length = 0;
        _this.selection_advert_code.length = 0;


        _this.submit_data.advert_appoint_code = _this.data;


        _this.$post(
            "/advert/getAdvertAppointDetails", {
              advert_appoint_code: _this.data
            }
          ).then(res => {

            _this.submit_data.remarks = res.data.remarks;


            for (let i = 0; i < res.data.synchronization.length; i++) {

              console.log(res.data.synchronization[i].name);

              _this.selection_advert_name.push(res.data.synchronization[i].name);
              _this.selection_img_url.push(res.data.synchronization[i].list_img.url);
              _this.time_box_arrway.push([res.data.synchronization[i].start_time.YmdHis,
                res.data.synchronization[i].end_time.YmdHis
              ]);
              _this.selection_advert_code.push(res.data.synchronization[i].advert_code);
              console.log(res.data);


            }

          }).catch((err) => {

          });


          _this.advertLists();


      },
    },
    data() {
      return {

        show: false,
        dialogVisible: false,

        // 详情组件
        advertAppointDetails_isShow: false,
        advertAppointDetails_arrway: [],

        // 存放点击广告列表的下标
        adver_list_index: '',

        //
        time_box_arrway: [],

        // 存放时间
        time_arrway: '',

        // 存放广告code
        list_advert_code: [],
        selection_advert_code: [],

        // 存放广告名称
        list_advert_name: [],
        selection_advert_name: [],

        // 存放图片路径
        list_img_url: [],
        selection_img_url: [],


        //翻页数据
        search_data: {
          page: 1,
          limit: 8,
          name: '',
        },

        result_data: [],
        search_rules: {
          page: {
            placeholder: '页码',
            rules: {
              required: true,
              message: '页码需要大于0',
              regulation: 'gt',
              rulesData: 0
            }
          },
          limit: {
            placeholder: '每页个数',
            rules: {
              required: true,
              message: '每页个数需在1-51之内',
              regulation: 'between',
              rulesData: [1, 51]
            }
          }
        },

        // 表单数据
        submit_data: {
          advert_appoint_code: '',
          synchronization: '',
          remarks: ''
        },


        submit_rules: {
          advert_appoint_code: {
            placeholder: '请选择广告指针',
            rules: {
              required: true,
              message: '广告指针错误',
              regulation: 'egt_str',
              rulesData: 0
            }
          },
          remarks: {
            placeholder: '请输入备注',
            rules: {
              required: false,
              message: '备注为200字以内',
              regulation: 'lt_str',
              rulesData: 200
            }
          }
        },

      };
    },
    created() {

      _this = this;

    },
    methods: {
      advertLists(){

        _this.list_advert_name=[];
        _this.list_img_url=[];
        _this.list_advert_code=[];

        _this.$post(
            "/advert/advertLists",
            _this.search_data,
            _this.search_rules
          )
          .then(res => {
            _this.result_data = res;




            // 广告名称
            for (let i = 0; i < res.data.length; i++) {
              _this.list_advert_name.push(res.data[i].name);
              _this.list_img_url.push(res.data[i].list_img.url);
              _this.list_advert_code.push(res.data[i].advert_code)
            }


            // 广告图片


          }).catch((err) => {

          })
      },
      closeDetailsDialog() {
        _this.advertAppointDetails_isShow = false;
      },
      openMore(index) {

        // 清空传到子组件的数据
        _this.advertAppointDetails_arrway.length = 0;

        // 将点击的code加入到数组传递至子组件
        _this.advertAppointDetails_arrway.push(_this.selection_advert_code[index]);
        console.log(_this.advertAppointDetails_arrway);

        // 传递到子组件的Boolean值
        _this.advertAppointDetails_isShow = !_this.advertAppointDetails_isShow;

      },

      // 删除已选广告
      delSelection(index) {

        // 删除对应的值
        _this.selection_advert_name.splice(index, 1);
        _this.selection_img_url.splice(index, 1);
        _this.time_box_arrway.splice(index, 1);
        _this.selection_advert_code.splice(index, 1)
      },

      // 选择时间弹出框确认按钮
      confirmBtn() {

        if (_this.time_arrway != '') {

          //在已选广告中添加广告列表中的点击项

          _this.selection_advert_name.push(_this.list_advert_name[_this.adver_list_index]);

          _this.selection_img_url.push(_this.list_img_url[_this.adver_list_index]);

          _this.selection_advert_code.push(_this.list_advert_code[_this.adver_list_index]);

          _this.time_box_arrway.push(_this.time_arrway);

          // 关闭弹出框
          _this.dialogVisible = false;

          _this.time_arrway = ''

        }
      },

      // 广告列表点击事件
      adverClick(index) {

        _this.dialogVisible = true;

        _this.adver_list_index = index;

      },

      // 关闭方法
      closeDialog() {

        _this.show = false;
        for (const key in _this.submit_data) {
          _this.submit_data[key] = '';
        }
        _this.value_advert_key = '';
        _this.value_mode_code = '';
      },

      // 指针下拉
      valueAdvert(val) {

        _this.submit_data.advert_code = val;

      },


      //翻页组件的回调
      pages_function(val) {


        _this.search_data.page = val;


        //初始化列表
        _this.advertLists();

      },

      // 提交
      onSubmit() {
        var synthesize_data = [];

        for (let i = 0; i < _this.selection_advert_code.length; i++) {
          var synthesize_Obj = {
            advert_code: '',
            start_time: '',
            end_time: ''
          }
          synthesize_Obj.advert_code = _this.selection_advert_code[i];
          synthesize_Obj.start_time = _this.time_box_arrway[i][0];
          synthesize_Obj.end_time = _this.time_box_arrway[i][1];
          synthesize_data.push(synthesize_Obj)
        }

        _this.submit_data.synchronization = JSON.stringify(synthesize_data);


        console.log(_this.submit_data);

        _this.$post(
            "/advert/saveAdvertAppointSubmit",
            _this.submit_data,
            _this.submit_rules
          )
          .then(res => {

            // 触发父组件自定义事件刷新表格
            _this.$emit('onSubmit');
            _this.closeDialog();
            this.$message.success(res.msg);


          }).catch(res => {

          })
      },

    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }

  .el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .avatar-uploader {
    width: 100px;
    height: 100px;
  }

  .avatar-uploader img {
    display: block;
    width: 100%;
    height: 100%;
  }

  .verify_remarks {
    font-size: 14px;
    color: #606266;
  }

  .quill-editor {
    width: 80%;
  }

  .adver-list,
  .adver-selection {
    display: flex;
    flex-wrap: wrap;
    max-height: 300px;
    overflow-y: auto;
  }

  .adver-selection {
    margin-bottom: 50px;
  }

  .adver-list {
    max-height: 500px;
  }

  .adver-list h4,
  .adver-selection h4 {
    width: 100%;
  }

  .adver-list .adver,
  .adver-selection .adver {
    width: 23%;
    padding: 10px;
    box-sizing: border-box;
    cursor: pointer;
    border: 1px solid #ccc;
    border-radius: 10px;
    margin: 10px;
    transition: .5s;
  }

  .adver-list .adver:hover,
  .adver-selection .adver:hover {
    border: 1px solid #409EFF;
    background-color: #409EFF;
  }

  .time-box {
    font-size: 14px;
    margin-top: 15px;
    border-top: 1px solid #ccc;
    padding: 5px 0;
  }

  .pagination {
    text-align: center;
  }
</style>